export class UTILS__url {
  static get(key: string) {
    const url = new URL(window.location.href);

    let out = url.searchParams.get(key);

    if (!out) out = '';

    return out;
  }

  static set(key: string, value: number | string | boolean) {
    const url = new URL(window.location.href);

    url.searchParams.set(key, String(value));

    return `${url.pathname}${url.search}`;
  }

  static delete(key: string) {
    const url = new URL(window.location.href);

    url.searchParams.delete(key);

    return `${url.pathname}${url.search}`;
  }
}
